import React, { useState, forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FilterExtention, Filter, FilterTypesEnum, Filters, FilterItem } from "../../../UI/Filter";
import { toCApi } from '../../../../utils'
import classes from "./CopyTocs.module.css";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import { ObjectTypeNamesEnum } from '../../../../models/ObjectTypeEnum'
import CoursesCopy from "../CoursesCopy";


const CopyTocs = forwardRef(({ setValid, studyGroupId, courses }, ref) => {
    const { texts, direction } = useSelector(state => state.translate);

    const [courseSelectedId, setCourseSelectedId] = useState(null);
    const dispatch = useDispatch()



    useImperativeHandle(ref, () => ({

        async stepNext() {
            const data = { objectType: ObjectTypeNamesEnum.StudyGroup, sourceObjectId: courseSelectedId, targetObjectId: studyGroupId }
            toCApi.toCOverlapPost({ toCOverlapInput: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.studyGroupsOverlapTocError, error: error, statusCode: response?.statusCode, message: "toCOverlapPost " + error.message, level: 2, component: "CopyTocs", line: 49 }))
                }
            })
        }
    }))



    return (
        <div className={`${classes[direction]} ${classes.CopyTocs}`}>
            <h2 className={classes.CopyLessons}>{texts.copyLessons}</h2>
            <div className={classes.CoursesWrap}>
                <FilterExtention list={courses} >
                    <Filters>
                        <Filter name="free" text={texts.freeFilter} type={FilterTypesEnum.free}></Filter>
                    </Filters>
                    <FilterItem>
                        <CoursesCopy setValid={setValid} courseSelectedId={courseSelectedId} setCourseSelectedId={setCourseSelectedId}></CoursesCopy>
                    </FilterItem>
                </FilterExtention>
            </div>
        </div>)
})

export default CopyTocs;
